import { render, staticRenderFns } from "./DashboardIbotech.vue?vue&type=template&id=05ed133c&scoped=true&"
import script from "./DashboardIbotech.vue?vue&type=script&lang=ts&"
export * from "./DashboardIbotech.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardIbotech.vue?vue&type=style&index=0&id=05ed133c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ed133c",
  null
  
)

export default component.exports